import { useTranslation } from 'react-i18next'
import { FormikProvider } from 'formik'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Grid,
  Box,
  Checkbox,
  FormControlLabel,
  Button,
  DialogActions,
} from '@mui/material'

import { Close } from '@mui/icons-material'
import {
  useBonusDialog,
  useWageringCategoryForm,
} from '@/views/bonus-engine/hooks'
import { DialogsEnum } from '@/enums'

import InputFormikAutocomplete from '@/views/components/input-formik-autocomplete/index.component'
import InputFormikField from '@/views/components/input-formik-field/index.component'

export const WageringContributionForm = () => {
  const { t } = useTranslation()

  const { dialog, toggleDialog } = useBonusDialog()

  const {
    categoriesList,
    formikWageringCategory,
    currentWageringCategory,
    handleSaveWageringContribution,
    setCurrentWageringCategory,
  } = useWageringCategoryForm()

  const handleCloseDialog = () => {
    toggleDialog(false, DialogsEnum.DIALOG_WAGERING_CONTRIBUTION_FORM)
    setCurrentWageringCategory()
  }

  return (
    <>
      <Dialog
        open={
          dialog.open &&
          dialog.id === DialogsEnum.DIALOG_WAGERING_CONTRIBUTION_FORM
        }
        aria-labelledby="dialog-games-form"
        fullWidth
        sx={{ '& .MuiPaper-root': { width: '500px' } }}
      >
        <DialogTitle id="dialog-games-form" sx={{ padding: '16px 24px 0px' }}>
          <Box display="flex" justifyContent="space-between" width="100%">
            <Box>{t('wageringContributionCategory')}</Box>
            <IconButton
              aria-label="close"
              onClick={handleCloseDialog}
              size="small"
            >
              <Close fontSize="inherit" />
            </IconButton>
          </Box>
        </DialogTitle>
        <FormikProvider value={formikWageringCategory}>
          <DialogContent>
            <Box overflow="hidden">
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <InputFormikAutocomplete
                    name="code"
                    label={t('labels.category')}
                    options={categoriesList}
                    getOptionLabel={(option) =>
                      option.id && option.id !== -1 ? option?.name : ''
                    }
                    chipTags
                    freeSolo
                  />
                </Grid>
                <Grid item xs={8}>
                  <InputFormikField
                    name="percentage"
                    label={t('labels.percentage')}
                    sx={{ marginTop: 1 }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControlLabel
                    label={t('labels.isBlocked')}
                    control={
                      <Checkbox
                        name="isBlocked"
                        checked={formikWageringCategory.values.isBlocked}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                          formikWageringCategory.setFieldValue(
                            'isBlocked',
                            !formikWageringCategory.values.isBlocked,
                          )
                        }
                      />
                    }
                  />
                </Grid>
              </Grid>
            </Box>
          </DialogContent>
        </FormikProvider>
        <DialogActions>
          <Button onClick={handleCloseDialog} className="red">
            {t('labels.cancel')}
          </Button>
          <Button
            disabled={
              !(formikWageringCategory.isValid && formikWageringCategory.dirty)
            }
            variant="contained"
            onClick={handleSaveWageringContribution}
          >
            {currentWageringCategory?.code
              ? t('labels.update')
              : t('labels.save')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
